/**
 * Theme JavaScript - UI interactions and animations
 */

document.addEventListener('DOMContentLoaded', () => {
  // Initialize all components
  initAnnouncementBar();
  initHeader();
  initMobileMenu();
  initSearchModal();
  initHeroSlideshow();
  initScrollReveal();
  initProductPage();
  initAccordions();

  // Rage-click fix: this file loads deferred, so on slow mobile loads the
  // search/hamburger buttons were visible seconds before their handlers
  // existed — clickstream showed 8-tap bursts on both, then exits. A tiny
  // inline stub in header.liquid records taps made before this point; replay
  // the intent now so the UI opens the moment it's able to.
  window.__mburHeaderReady = true;
  const pendingTap = window.__mburPendingTap;
  window.__mburPendingTap = null;
  if (pendingTap === 'search') {
    const searchBtn = document.querySelector('.js-search-toggle');
    if (searchBtn) searchBtn.click();
  } else if (pendingTap === 'menu') {
    const menuBtn = document.querySelector('.js-menu-toggle');
    if (menuBtn) menuBtn.click();
  }
});

// ================================
// Announcement Bar
// ================================
function initAnnouncementBar() {
  const slides = document.querySelectorAll('.announcement-bar__slide');
  if (slides.length <= 1) return;

  let currentIndex = 0;

  setInterval(() => {
    slides[currentIndex].classList.remove('is-active');
    currentIndex = (currentIndex + 1) % slides.length;
    slides[currentIndex].classList.add('is-active');
  }, 5000);
}

// ================================
// Header
// ================================
function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > 100) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }

    lastScroll = currentScroll;
  }, { passive: true });
}

// ================================
// Mobile Menu
// ================================
function initMobileMenu() {
  const toggleBtn = document.querySelector('.js-menu-toggle');
  const menu = document.querySelector('.js-mobile-menu');
  const closeButtons = document.querySelectorAll('.js-menu-close');

  if (!toggleBtn || !menu) return;

  // Function to open menu
  function openMenu() {
    menu.classList.add('is-open');
    document.body.classList.add('no-scroll', 'is-menu-open');
    toggleBtn.setAttribute('aria-expanded', 'true');

    // Hide header when menu opens to prevent z-index conflicts
    const headerSelectors = [
      '.site-header-logo-bar',
      '.site-header',
      '.section-header',
      'header',
      '.header',
      '.shopify-section-header',
      '[role="banner"]',
      '#shopify-section-header',
      '.header-section'
    ];

    headerSelectors.forEach(selector => {
      const element = document.querySelector(selector);
      if (element && !element.classList.contains('mobile-menu')) {
        element.style.display = 'none';
      }
    });

    // Push state to browser history so back button closes menu
    history.pushState({ menuOpen: true }, '');
  }

  // Function to close menu
  function closeMenu() {
    menu.classList.remove('is-open');
    document.body.classList.remove('no-scroll', 'is-menu-open');
    toggleBtn.setAttribute('aria-expanded', 'false');

    // Show header when menu closes
    const headerSelectors = [
      '.site-header-logo-bar',
      '.site-header',
      '.section-header',
      'header',
      '.header',
      '.shopify-section-header',
      '[role="banner"]',
      '#shopify-section-header',
      '.header-section'
    ];

    headerSelectors.forEach(selector => {
      const element = document.querySelector(selector);
      if (element && !element.classList.contains('mobile-menu')) {
        element.style.display = '';
      }
    });

    // Close any open submenus
    document.querySelectorAll('.is-submenu-open').forEach(item => {
      item.classList.remove('is-submenu-open');
    });
  }

  toggleBtn.addEventListener('click', openMenu);

  // Add event listeners to close buttons with better error handling
  if (closeButtons && closeButtons.length > 0) {
    closeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeMenu();
        // Go back in history to remove the menu state
        if (history.state && history.state.menuOpen) {
          history.back();
        }
      });
    });
  } else {
    console.warn('Mobile menu close buttons not found');
  }

  // Handle browser back button
  window.addEventListener('popstate', (event) => {
    if (menu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // Submenu toggles
  document.querySelectorAll('.js-submenu-toggle').forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggle.closest('.mobile-menu__item').classList.add('is-submenu-open');
    });
  });

  document.querySelectorAll('.js-submenu-back').forEach(back => {
    back.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      // Find the parent menu item with submenu (has the is-submenu-open class)
      const parentItem = back.closest('.mobile-menu__submenu').parentElement;
      if (parentItem) {
        parentItem.classList.remove('is-submenu-open');
      }
    });
  });

  // Allow submenu links to navigate without closing menu
  document.querySelectorAll('.mobile-menu__submenu a').forEach(link => {
    link.addEventListener('click', (e) => {
      // Let the link navigate normally, but close the menu after navigation starts
      setTimeout(() => {
        closeMenu();
      }, 100);
    });
  });

  // Close menu on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) {
      closeMenu();
      if (history.state && history.state.menuOpen) {
        history.back();
      }
    }
  });

  // ================================
  // Swipe to Close Mobile Menu
  // ================================
  const panel = document.querySelector('.mobile-menu__panel');
  if (!panel) return;

  let startX = 0;
  let currentX = 0;
  let isSwiping = false;

  panel.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    currentX = startX;
    isSwiping = true;
    panel.style.transition = 'none';
  }, { passive: true });

  panel.addEventListener('touchmove', function(e) {
    if (!isSwiping) return;
    currentX = e.touches[0].clientX;
    const diff = currentX - startX;
    // Only allow swiping left (negative diff)
    if (diff < 0) {
      panel.style.transform = 'translateX(' + diff + 'px)';
    }
  }, { passive: true });

  panel.addEventListener('touchend', function() {
    if (!isSwiping) return;
    isSwiping = false;
    const diff = currentX - startX;

    // If swiped left more than 200px, close the menu
    if (diff < -200) {
      // Animate the panel off screen first
      panel.style.transition = 'transform 0.3s ease';
      panel.style.transform = 'translateX(-100%)';

      // After animation completes, close the menu and clean up
      setTimeout(function() {
        closeMenu();
        if (history.state && history.state.menuOpen) {
          history.back();
        }
        panel.style.transition = '';
        panel.style.transform = '';
      }, 300);
    } else {
      // Snap back if swipe was too small
      panel.style.transition = 'transform 0.3s ease';
      panel.style.transform = '';
      setTimeout(function() {
        panel.style.transition = '';
      }, 300);
    }
  });
}

// ================================
// Search Modal
// ================================
function initSearchModal() {
  const toggleBtn = document.querySelector('.js-search-toggle');
  const modal = document.querySelector('.js-search-modal');
  const closeButtons = document.querySelectorAll('.js-search-close');
  const input = document.querySelector('.js-search-input');

  if (!toggleBtn || !modal) return;

  toggleBtn.addEventListener('click', () => {
    modal.classList.add('is-open');
    document.body.classList.add('no-scroll');
    // Focus synchronously: iOS Safari only opens the keyboard when focus()
    // runs inside the tap gesture — the old 300ms-delayed focus was silently
    // ignored there (search opened but "didn't accept" typing). The delayed
    // retry stays for browsers that drop focus during the open animation.
    input?.focus();
    setTimeout(() => input?.focus(), 300);
  });

  closeButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      modal.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    });
  });

  // Close on escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      modal.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }
  });
}

// ================================
// Hero Slideshow
// ================================
function initHeroSlideshow() {
  const slideshow = document.querySelector('.hero-slideshow');
  if (!slideshow) return;

  const slides = slideshow.querySelectorAll('.hero-slide');
  const dots = slideshow.querySelectorAll('.hero-slideshow__dot');
  const prevBtn = slideshow.querySelector('.js-hero-prev');
  const nextBtn = slideshow.querySelector('.js-hero-next');

  if (slides.length <= 1) return;

  let currentIndex = 0;
  let autoplayInterval;

  function goToSlide(index) {
    slides[currentIndex].classList.remove('is-active');
    dots[currentIndex]?.classList.remove('is-active');

    currentIndex = (index + slides.length) % slides.length;

    slides[currentIndex].classList.add('is-active');
    dots[currentIndex]?.classList.add('is-active');
  }

  function nextSlide() {
    goToSlide(currentIndex + 1);
  }

  function prevSlide() {
    goToSlide(currentIndex - 1);
  }

  function startAutoplay() {
    autoplayInterval = setInterval(nextSlide, 6000);
  }

  function stopAutoplay() {
    clearInterval(autoplayInterval);
  }

  // Event listeners
  prevBtn?.addEventListener('click', () => {
    stopAutoplay();
    prevSlide();
    startAutoplay();
  });

  nextBtn?.addEventListener('click', () => {
    stopAutoplay();
    nextSlide();
    startAutoplay();
  });

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      stopAutoplay();
      goToSlide(index);
      startAutoplay();
    });
  });

  // Pause on hover
  slideshow.addEventListener('mouseenter', stopAutoplay);
  slideshow.addEventListener('mouseleave', startAutoplay);

  // Start autoplay
  startAutoplay();
}

// ================================
// Scroll Reveal Animations
// ================================
function initScrollReveal() {
  const elements = document.querySelectorAll('[data-scroll-reveal]');
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // Add stagger delay based on siblings
        const siblings = entry.target.parentElement?.querySelectorAll('[data-scroll-reveal]');
        const siblingIndex = siblings ? Array.from(siblings).indexOf(entry.target) : 0;

        setTimeout(() => {
          entry.target.classList.add('is-visible');
        }, siblingIndex * 100);

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  elements.forEach(el => observer.observe(el));
}

// ================================
// Product Page
// ================================
function initProductPage() {
  // Gallery thumbnails
  const mainImage = document.querySelector('.js-main-image');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');

      if (mainImage) {
        mainImage.src = thumb.dataset.src;
      }
    });
  });

  // Size buttons
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const container = btn.closest('.product-option__sizes');
      container?.querySelectorAll('.size-btn').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      // Update variant
      updateVariant();
    });
  });

  // Quantity selector
  document.querySelectorAll('.js-qty-minus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      if (input && parseInt(input.value) > 1) {
        input.value = parseInt(input.value) - 1;
      }
    });
  });

  document.querySelectorAll('.js-qty-plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      if (input) {
        input.value = parseInt(input.value) + 1;
      }
    });
  });

  // Option selects
  document.querySelectorAll('.js-option-select').forEach(select => {
    select.addEventListener('change', updateVariant);
  });
}

function updateVariant() {
  const productJson = document.getElementById('product-json');
  if (!productJson) return;

  const product = JSON.parse(productJson.textContent);
  const options = [];

  // Get selected size
  const selectedSize = document.querySelector('.size-btn.is-selected');
  if (selectedSize) {
    options.push(selectedSize.dataset.value);
  }

  // Get other selected options
  document.querySelectorAll('.js-option-select').forEach(select => {
    options.push(select.value);
  });

  // Find matching variant
  const variant = product.variants.find(v => {
    return v.options.every((opt, i) => opt === options[i]);
  });

  if (variant) {
    // Update hidden input
    const variantInput = document.querySelector('.js-variant-id');
    if (variantInput) {
      variantInput.value = variant.id;
    }

    // Update price
    const priceEl = document.querySelector('.product-info__price--current');
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }

    // Update button state
    const addButton = document.querySelector('.js-add-to-cart');
    if (addButton) {
      if (variant.available) {
        addButton.disabled = false;
        addButton.textContent = 'Add to Cart';
      } else {
        addButton.disabled = true;
        addButton.textContent = 'Sold Out';
      }
    }

    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ================================
// Accordions
// ================================
function initAccordions() {
  // Product accordions
  document.querySelectorAll('.js-accordion-toggle').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const accordion = toggle.closest('.product-accordion');
      accordion?.classList.toggle('is-open');
    });
  });

  // FAQ accordions
  document.querySelectorAll('.js-faq-toggle').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.faq-item');
      item?.classList.toggle('is-open');
    });
  });
}

// ================================
// Products Slider (Optional)
// ================================
function initProductsSlider() {
  const sliders = document.querySelectorAll('.products-slider');

  sliders.forEach(slider => {
    const track = slider.querySelector('.products-slider__track');
    const prevBtn = slider.querySelector('.js-slider-prev');
    const nextBtn = slider.querySelector('.js-slider-next');

    if (!track || !prevBtn || !nextBtn) return;

    const cardWidth = track.querySelector('.product-card')?.offsetWidth || 300;
    const gap = 24;
    let scrollAmount = cardWidth + gap;

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  });
}

// Call additional initializations
document.addEventListener('DOMContentLoaded', initProductsSlider);
document.addEventListener('DOMContentLoaded', initProductCardVariants);
document.addEventListener('DOMContentLoaded', initDragScroll);

// ================================
// Product Card Variant Slider
// ================================
function initProductCardVariants(container = document) {
  // Ensure container is a valid DOM element or document
  if (!container || typeof container.querySelectorAll !== 'function') {
    container = document;
  }
  const productCards = container.querySelectorAll('.product-card');

  productCards.forEach(card => {
    const track = card.querySelector('.js-variants-track');
    const indicator = card.querySelector('.js-variant-indicator');
    const variantBtns = card.querySelectorAll('.js-variant-select');
    const variantInput = card.querySelector('.js-variant-input');
    const priceEl = card.querySelector('.product-card__price--current');
    const productImage = card.querySelector('.js-product-image');

    // Initialize indicator position
    if (indicator && variantBtns.length > 0) {
      const selectedBtn = card.querySelector('.js-variant-select.is-selected') || variantBtns[0];
      updateIndicator(indicator, selectedBtn);
    }

    // Variant button selection
    variantBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Don't select unavailable variants
        if (btn.classList.contains('is-unavailable')) return;

        // Update selection state
        variantBtns.forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        // Slide the indicator to the new position
        if (indicator) {
          updateIndicator(indicator, btn);
        }

        // Update hidden input
        const variantId = btn.dataset.variantId;
        if (variantInput && variantId) {
          variantInput.value = variantId;
        } else {
          console.warn('Could not update variant input:', { variantInput: !!variantInput, variantId });
        }

        // Update price
        const price = btn.dataset.variantPrice;
        if (priceEl && price) {
          priceEl.textContent = price;
        }

        // Update product image
        if (productImage) {
          const variantImage = btn.dataset.variantImage;
          if (variantImage) {
            // Update both src and srcset to ensure image changes
            productImage.src = variantImage;
            productImage.srcset = variantImage;
          } else {
            // Fall back to original image if variant has no image
            const originalSrc = productImage.dataset.originalSrc;
            const originalSrcset = productImage.dataset.originalSrcset;
            if (originalSrc) {
              productImage.src = originalSrc;
              productImage.srcset = originalSrcset || originalSrc;
            }
          }
        }
      });
    });
  });

  // Update indicator position and size
  // Optimized to batch layout reads before writes (prevent forced reflow)
  function updateIndicator(indicator, btn) {
    if (!indicator || !btn) return;

    // Batch all layout reads first
    const btnRect = btn.getBoundingClientRect();
    const btnOffsetLeft = btn.offsetLeft;
    const btnWidth = btnRect.width;

    // Then batch all style writes (prevents forced reflow)
    indicator.style.left = btnOffsetLeft + 'px';
    indicator.style.width = btnWidth + 'px';
  }
}

// Make globally accessible for dynamic content loading
window.initProductCardVariants = initProductCardVariants;

// ================================
// Drag Scroll for Variant Slider
// ================================
function initDragScroll(container = document) {
  // Ensure container is a valid DOM element or document
  if (!container || typeof container.querySelectorAll !== 'function') {
    container = document;
  }
  const sliders = container.querySelectorAll('.js-drag-scroll');

  sliders.forEach(slider => {
    let isDown = false;
    let startX;
    let scrollLeft;
    let velX = 0;
    let momentumID;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('is-dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      cancelMomentumTracking();
    });

    slider.addEventListener('mouseleave', () => {
      if (isDown) {
        isDown = false;
        slider.classList.remove('is-dragging');
        beginMomentumTracking();
      }
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('is-dragging');
      beginMomentumTracking();
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      const prevScrollLeft = slider.scrollLeft;
      slider.scrollLeft = scrollLeft - walk;
      velX = slider.scrollLeft - prevScrollLeft;
    });

    // Touch events for mobile
    slider.addEventListener('touchstart', (e) => {
      isDown = true;
      startX = e.touches[0].pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      cancelMomentumTracking();
    }, { passive: true });

    slider.addEventListener('touchend', () => {
      isDown = false;
      beginMomentumTracking();
    });

    slider.addEventListener('touchmove', (e) => {
      if (!isDown) return;
      const x = e.touches[0].pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      const prevScrollLeft = slider.scrollLeft;
      slider.scrollLeft = scrollLeft - walk;
      velX = slider.scrollLeft - prevScrollLeft;
    }, { passive: true });

    // Momentum scrolling
    function beginMomentumTracking() {
      cancelMomentumTracking();
      momentumID = requestAnimationFrame(momentumLoop);
    }

    function cancelMomentumTracking() {
      cancelAnimationFrame(momentumID);
    }

    function momentumLoop() {
      slider.scrollLeft += velX;
      velX *= 0.92;
      if (Math.abs(velX) > 0.5) {
        momentumID = requestAnimationFrame(momentumLoop);
      }
    }
  });
}

// Make globally accessible for dynamic content loading
window.initDragScroll = initDragScroll;

// ================================
// Quick View Popup
// ================================
function initQuickView() {
  const overlay = document.querySelector('.js-quick-view-overlay');
  const popup = document.querySelector('.js-quick-view-popup');
  const content = document.querySelector('.js-quick-view-content');
  const closeBtn = document.querySelector('.js-quick-view-close');

  if (!overlay || !popup || !content) return;

  // Handle quick view button clicks
  document.addEventListener('click', (e) => {
    const quickViewBtn = e.target.closest('.js-quick-view');
    if (quickViewBtn) {
      e.preventDefault();
      e.stopPropagation();
      const productHandle = quickViewBtn.dataset.productHandle;
      const productUrl = quickViewBtn.dataset.productUrl;
      if (productHandle || productUrl) {
        openQuickView(productHandle, productUrl);
      }
    }
  });

  // Close handlers
  closeBtn?.addEventListener('click', closeQuickView);
  overlay?.addEventListener('click', closeQuickView);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) {
      closeQuickView();
    }
  });

  function openQuickView(handle, url) {
    // Show loading state
    content.innerHTML = `
      <div class="quick-view-popup__loading">
        <div class="quick-view-popup__spinner"></div>
        <span>Loading...</span>
      </div>
    `;
    overlay.classList.add('is-open');
    popup.classList.add('is-open');
    document.body.classList.add('no-scroll');

    // Fetch product data
    const fetchUrl = url ? `${url}?view=quick-view` : `/products/${handle}?view=quick-view`;
    fetch(fetchUrl)
      .then(response => response.text())
      .then(html => {
        content.innerHTML = html;
        initQuickViewInteractions();
      })
      .catch(error => {
        console.error('Quick view error:', error);
        content.innerHTML = `
          <div class="quick-view-popup__loading">
            <span>Failed to load product. Please try again.</span>
            <a href="${url || '/products/' + handle}" class="btn btn--secondary" style="margin-top: 16px;">View Product</a>
          </div>
        `;
      });
  }

  function closeQuickView() {
    overlay.classList.remove('is-open');
    popup.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }

  function initQuickViewInteractions() {
    // Gallery thumbnails
    const mainImage = popup.querySelector('.js-qv-main-image');
    const thumbs = popup.querySelectorAll('.js-qv-thumb');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImage) {
          mainImage.src = thumb.dataset.src;
        }
      });
    });

    // Variant selection
    const variantBtns = popup.querySelectorAll('.js-qv-variant');
    const variantInput = popup.querySelector('.js-qv-variant-input');
    const priceEl = popup.querySelector('.js-qv-price');
    const addBtn = popup.querySelector('.js-qv-add-to-cart');

    variantBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-unavailable')) return;

        variantBtns.forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        if (variantInput) {
          variantInput.value = btn.dataset.variantId;
        }
        if (priceEl && btn.dataset.price) {
          priceEl.textContent = btn.dataset.price;
        }
        if (addBtn) {
          if (btn.dataset.available === 'true') {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
          }
        }
      });
    });

    // Quantity buttons
    const qtyMinus = popup.querySelector('.js-qv-qty-minus');
    const qtyPlus = popup.querySelector('.js-qv-qty-plus');
    const qtyInput = popup.querySelector('.js-qv-qty-input');

    qtyMinus?.addEventListener('click', () => {
      if (qtyInput && parseInt(qtyInput.value) > 1) {
        qtyInput.value = parseInt(qtyInput.value) - 1;
      }
    });

    qtyPlus?.addEventListener('click', () => {
      if (qtyInput) {
        qtyInput.value = parseInt(qtyInput.value) + 1;
      }
    });

    // Add to cart
    const form = popup.querySelector('.js-qv-form');
    form?.addEventListener('submit', async (e) => {
      e.preventDefault();

      const formData = new FormData(form);
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          addBtn.textContent = 'Added!';
          setTimeout(() => {
            closeQuickView();
            // Optionally open cart drawer
            document.querySelector('.js-cart-drawer')?.classList.add('is-open');
            document.body.classList.add('no-scroll');
          }, 800);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
        alert('Failed to add to cart. Please try again.');
      }
    });
  }
}

// Initialize quick view
document.addEventListener('DOMContentLoaded', initQuickView);
